// Vendor Libs
import cloneDeep from 'lodash.clonedeep';

// Action Types
import {actionTypes} from '../action-types';

const initialState = {};

const actions = {
  [actionTypes.ALIAS_DELETE_DONE]: (state, payload) => {
    const {status, error, id} = payload;
    return {
      ...cloneDeep(state),
      status,
      error,
      id,
    };
  },

  [actionTypes.ALIAS_ADD_DONE]: (state, payload) => {
    const {status, error, id} = payload;
    return {
      ...cloneDeep(state),
      status,
      error,
      id,
    };
  },
};

export const genreReducer = (state = initialState, action) =>
  actions[action.type] ? actions[action.type](state, action.payload) : state;
